import React from "react";
import EmbedIFrameAutoHeight from "./EmbedIFrameAutoHeight";

export interface EmbedIFrameProps {
  url: string;
  title?: string;
  height?: string;
  width?: string;
  allow?: string;
  sandbox?: string;
}

function normalizeDimension(value: string | undefined, fallback: string): string {
  if (!value) return fallback;
  const trimmed = String(value).trim();
  if (!trimmed) return fallback;
  return /^\d+$/.test(trimmed) ? `${trimmed}px` : trimmed;
}

export default function EmbedIFrame(props: EmbedIFrameProps) {
  const { url, title, height, width, allow, sandbox } = props;

  if (!url) return null;

  const normalizedWidth = normalizeDimension(width, "100%");
  const hasExplicitHeight = typeof height === "string" && height.trim().length > 0;

  if (!hasExplicitHeight) {
    return (
      <div className="embed-iframe-container">
        <EmbedIFrameAutoHeight
          url={url}
          title={title}
          width={normalizedWidth}
          allow={allow}
          sandbox={sandbox}
        />
      </div>
    );
  }

  const normalizedHeight = normalizeDimension(height, "600px");

  return (
    <div className="embed-iframe-container">
      <iframe
        src={url}
        title={title}
        width={normalizedWidth}
        height={normalizedHeight}
        allow={allow}
        sandbox={sandbox as any}
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        style={{ border: 0, width: normalizedWidth, height: normalizedHeight }}
      />
    </div>
  );
}
